import { KindEntity } from '@eastcoal/api/system/interface'

import { onFieldInputValueChange } from '@eastcoal/formily/exports/core'

export const productNameEffect = () => {
  onFieldInputValueChange('kindList', field => {
    const productNameField = field.query('productName').take()
    productNameField?.setState(state => {
      state.value = field.value?.map((item: KindEntity) => item.name)?.join()
    })
  })
}
